<ng-container *ngIf="themeInput$ | async"></ng-container>
<div class="wizard-theme">
  <h5 class="wizard-heading-1">{{ "logo" | translation }}</h5>
  <p class="wizard-content">
    {{ "upload_a_logo_here_wizard_lingo" | translation }}
  </p>
  <div class="wizard-theme-top-row">
    <div>
      <div
        #logo
        class="wizard-theme-logo-wrapper"
        (click)="file.click()"
        id="wizard-theme-logo-wrapper"
      >
        <div
          class="wizard-theme-select-logo-call-to-action-container"
          *ngIf="!showLogo"
        >
          <i class="fas fa-plus"></i>
          <p>{{ "select_your_logo" | translation }}</p>
        </div>
      </div>
      <button
        class="wizard-theme-button"
        (click)="removeLogo()"
        style="margin-right: 32px"
        nbButton
        ghost
      >
        {{ "remove_logo" | translation }}
      </button>
      <button
        class="wizard-theme-button"
        (click)="file.click()"
        nbButton
        status="secondary"
        *ngIf="showLogo"
      >
        {{ "replace_logo" | translation }}
      </button>
      <button
        class="wizard-theme-button"
        (click)="file.click()"
        nbButton
        status="secondary"
        *ngIf="!showLogo"
      >
        {{ "Upload Logo" | translation }}
      </button>
    </div>
    <div>
      <p>{{ "supported_file_types_lingo" | translation }}</p>
      <p>{{ "max_file_size" | translation }}: <b>3 MB</b></p>
    </div>
  </div>

  <input
    accept="image/png, image/gif, image/jpeg, image/svg+xml"
    #file
    type="file"
    style="visibility: hidden"
    (change)="onFileChanged($event); file.value = ''"
  />

  <h5 class="wizard-heading-1">{{ "colors" | translation }}</h5>

  <div class="color-containers">
    <div class="color-container">
      <label class="color-label">{{
        "primary_brand_color" | translation
      }}</label>
      <button
        ngDefaultControl
        class="color-button wizard-theme-button"
        cpAlphaChannel="disabled"
        [(colorPicker)]="$primary"
        [(ngModel)]="$primary"
        (colorPickerChange)="
          updateButtonTextColor();
          updateCheckWCAG($button_text_color, $primary, 'example1Text')
        "
      >
        <div
          [style.background-color]="$primary"
          class="color-button-display-color"
        ></div>
        <div class="color-button-action-text">
          <p>{{ "select_color" | translation }}</p>
        </div>
      </button>
    </div>

    <div class="color-container">
      <label class="color-label">{{
        "secondary_brand_color" | translation
      }}</label>
      <button
        ngDefaultControl
        class="color-button wizard-theme-button"
        cpAlphaChannel="disabled"
        [(colorPicker)]="$info"
        [(ngModel)]="$info"
        (colorPickerChange)="updateCheckWCAG($primary, $info, 'example2Text')"
      >
        <div
          [style.background-color]="$info"
          class="color-button-display-color"
        ></div>
        <div class="color-button-action-text">
          <p>{{ "select_color" | translation }}</p>
        </div>
      </button>
    </div>
  </div>

  <h5 class="wizard-heading-1">{{ "styling_previews" | translation }}</h5>
  <div class="previews-wrapper">
    <div class="previews-container-button">
      <label class="color-label">{{ "primary_button" | translation }}</label>

      <div class="previews-button-container">
        <p
          class="previews-button-status"
          style="color: #c24848"
          *ngIf="example1Text?.includes('Failed'); else default1"
        >
          <i class="fa-solid fa-triangle-exclamation"></i>

          {{ example1Text }}
        </p>
        <ng-template #default1>
          <p class="previews-button-status">{{ example1Text }}</p>
        </ng-template>
        <button
          (mouseover)="isPrimaryButtonHover = true"
          (mouseout)="isPrimaryButtonHover = false"
          class="previews-example-button wizard-theme-button"
          nbButton
          [style.width]="'236.25px'"
          [style.height]="'40px'"
          [style.transition]="'all 0.3s'"
          [style.color]="$button_text_color"
          [style.border-color]="$primary"
          [style.opacity]="isPrimaryButtonHover ? '.8' : '1'"
          [style.background-color]="$primary"
          [style.cursor]="'pointer'"
          [style.margin]="'0px'"
        >
          {{ "button_text" | translation }}
        </button>
      </div>
    </div>
    <div class="previews-container-button">
      <label class="color-label">{{ "navigation_item" | translation }}</label>

      <div class="previews-button-container">
        <p
          class="previews-button-status"
          style="color: #c24848"
          *ngIf="example2Text?.includes('Failed'); else default2"
        >
          <i class="fa-solid fa-triangle-exclamation"></i>
          {{ example2Text }}
        </p>
        <ng-template #default2>
          <p class="previews-button-status">
            {{ example2Text }}
          </p>
        </ng-template>
        <div
          class="previews-nav-item"
          [style.color]="$primary"
          [style.background-color]="$info"
          [style.cursor]="'pointer'"
          [style.margin]="'0px'"
        >
          <div class="previews-nav-icon">
            <nb-icon
              [style.color]="$primary"
              [style.cursor]="'pointer'"
              pack="fas"
              icon="toolbox"
            ></nb-icon>
          </div>
          <div class="previews-nav-label">{{ "admin" | translation }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="wizard-button-container">
    <button
      nbButton
      ghost
      class="text-link-color"
      [disabled]="isProcessing"
      (click)="updateTheme()"
    >
      <i class="fa-light fa-arrows-rotate" style="margin-right: 10px"></i>
      {{ "update_theme" | translation }}
    </button>
  </div>
</div>
